// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"257049b6","443":"acc821da","945":"310601cc"}[chunkId] + ".chunk.css";
};